import { NotesState, initialNotesState, WorkspaceNotesFetchParams } from '@nx-frontend/shared/store/notes';
import { GetNotesResult } from '@nx-frontend/shared/types';
import { NotesStoreNote } from '@nx-frontend/shared/types';

export interface NoteItemToNotesStoreParams {
  items: GetNotesResult;
  workspaceId: string;
}

export function folderItemToNotesStore(params: NoteItemToNotesStoreParams): NotesState {
  const { items, workspaceId } = params;
  const itemsMap: Record<string, NotesStoreNote> = {};
  const totalFolders = items.items.filter((item) => item.type === 'folder').length;
  const totalRoot = items.items.filter((item) => item.type === 'folder' && item.parentId === 'root').length;
  const fetch: Record<string, WorkspaceNotesFetchParams> = {
    'folder-root': {
      total: totalRoot,
      offset: totalRoot,
      isFetching: false,
      isLoaded: true,
    },
    'folder-all': {
      total: totalFolders,
      offset: totalFolders,
      isFetching: false,
      isLoaded: true,
    },
  };
  items.items.forEach((item) => {
    const fetchKey = item.type + '-' + item.globalId;
    itemsMap[item.globalId] = item;
    if (item.type === 'folder') {
      fetch[fetchKey] = {
        total: 0,
        offset: 0,
        isFetching: false,
        isLoaded: true,
      };
    }
  });

  return {
    ...initialNotesState,
    workspaces: {
      [workspaceId]: {
        entities: itemsMap,
        fetch,
      },
    },
  };
}
